<section *ngIf="canViewPerformance === true">

    <div class="flex justify-between items-end" >
        <div>
            <h1> {{type}} : {{data?.group_name || data?.department_name || data?.class_name || ''}} </h1>
        </div>
        <div *ngIf="year_filter_performance === true">
            <select class="select select-sm select-bordered w-full max-w-xs ">
                <option>This Year</option>
                <option>Acedmic Year</option>
                <option>Calender Year</option>
                <option>Lifetime</option>
                <option>Custom</option>
            </select>
        </div>
    </div>

    <div class="my-5 max-w-md">
        <div role="tablist" class="tabs tabs-boxed gap-1">
            <a role="tab" class="tab" *ngIf="video_performance === true">Video Content</a>
            <a role="tab" class="tab tab-active" *ngIf="flashcard_performance === true">Flashcard</a>
            <a role="tab" class="tab" *ngIf="ai_test_performance === true">AI Test</a>
        </div>
    </div>

    <div class="bg-white border rounded-lg p-5">
        <app-bar-chart [height]="300"></app-bar-chart>
    </div>

    <div class="p-5 bg-white rounded-lg mt-5 border">

        <div class="bg-zinc-100  rounded-lg flex items-center max-w-md px-3"><i class="ri-search-2-line"></i> 
            <input [(ngModel)]="searchStr" (input)="serach()"  type="text" placeholder="Search" class="bg-transparent outline-none ml-2 w-full py-2"></div>

        <div class="overflow-x-auto mt-3">
            <table class="table table-auto w-full">
                <!-- head -->
                <thead>
                    <tr>
                        <th class="w-14">#</th>
                        @for (column of getColumns(type); track $index) {
                        <th class="w-auto" *ngIf="(column === 'overall' && overall_performance_list === true) || (column === 'video' && video_performance === true) || (column === 'flashcard' && flashcard_performance === true) || (column === 'ai-test' && ai_test_performance === true) || column === 'student name' || column === 'class' || column === 'batch'">{{column}}</th>
                        }
                        <th class="w-24">action</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- row 1 -->

                    @let tableData = data?.students ?? [];
                    @if (tableData && tableData.length > 0) {
                    @for (i of tableData; track $index) {
                    @let studentRecordId = getStudentRecordId(i);
                    <tr>
                        <th>{{$index+1}}</th>
                        <td class="whitespace-nowrap">{{i?.first_name}} {{i?.last_name}}</td>
                        <td class="" *ngIf="overall_performance_list === true">{{i?.overall_percentage ?? 0}}</td>
                        <td class="" *ngIf="video_performance === true">{{i?.videos_percentage ?? 0}}</td>
                        <td class="" *ngIf="flashcard_performance === true">{{i?.flashcardwatch_precentage ?? 0}}</td>
                        <td class="" *ngIf="ai_test_performance === true">{{i?.aitest_percentage ?? 0}}</td>
                        <td>
                            <div class="flex gap-2 justify-center">
                                <a class="btn btn-sm flex items-center btn-light"
                                    *ngIf="performance_view_student === true && studentRecordId"
                                    [routerLink]="['/student', studentRecordId]"
                                    aria-label="View student record">
                                    <i class="ri-eye-line"></i>
                                </a>
                                <button class="btn btn-sm flex items-center btn-light" *ngIf="performance_communicate === true"><i
                                        class="ri-message-3-line"></i></button>
                                <button class="btn btn-sm flex items-center btn-light" *ngIf="type === 'group'"
                                    [disabled]="removingStudentId === i?.id" (click)="removeStudentFromGroup(i)"
                                    aria-label="Remove student from group">
                                    @if (removingStudentId === i?.id) {
                                    <i class="ri-loader-2-line animate-spin"></i>
                                    } @else {
                                    <i class="ri-delete-bin-line text-red-500"></i>
                                    }
                                </button>
                            </div>
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </div>



    </div>


</section>
